export default {
  'zh-HK': {
    '修改 UPlus-S1': '修改 UPlus-S1',
    'Orbit 策略信息不完整，请刷新后重试': 'Orbit 策略資料不完整，請重新整理後重試',
    'Orbit 策略操作失败': 'Orbit 策略操作失敗',
    'Orbit 策略操作成功': 'Orbit 策略操作成功',
    'Orbit 数据读取失败': 'Orbit 資料讀取失敗',
    'Orbit 策略状态已更新，请核对后重新确认': 'Orbit 策略狀態已更新，請核對後重新確認',
    'Orbit 委托已更新，已重新加载最新记录': 'Orbit 委託已更新，已重新載入最新記錄'
  },
  en: {
    '加载更多': 'Load more',
    '修改 UPlus-S1': 'Edit UPlus-S1',
    '投入金额不能超过交易所可用余额': 'Investment cannot exceed the available exchange balance',
    'Orbit 策略信息不完整，请刷新后重试': 'Orbit strategy information is incomplete. Refresh and try again.',
    'Orbit 策略操作失败': 'Orbit strategy operation failed',
    'Orbit 策略操作成功': 'Orbit strategy updated successfully',
    'Orbit 数据读取失败': 'Failed to load Orbit data',
    '历史策略不可操作': 'Historical strategies cannot be modified',
    'Orbit 策略状态已更新，请核对后重新确认': 'The Orbit strategy has changed. Review the updated details and confirm again.',
    'Orbit 委托已更新，已重新加载最新记录': 'Orbit orders have changed. The latest orders have been reloaded.',
    '请先绑定 OKX 交易所 API': 'Bind your OKX exchange API first',
    '当前账号已冻结，无法创建策略': 'This account is frozen. Strategies cannot be created.',
    '确认恢复当前策略？': 'Resume this strategy?',
    '已加载全部委托': 'All orders loaded',
    '暂无当前仓位': 'No current positions',
    '暂无当前委托': 'No current orders',
    '买入平空': 'Buy to close short',
    '买入开多': 'Buy to open long',
    '卖出平多': 'Sell to close long',
    '卖出开空': 'Sell to open short',
    '初始保证金': 'Initial margin',
    '保证金率': 'Margin ratio',
    '已成交数量': 'Filled quantity',
    '完成交易': 'Completed trades',
    '状态未知': 'Unknown status',
    '策略参数': 'Strategy parameters'
  },
  ko: {
    '加载更多': '더 보기',
    '修改 UPlus-S1': 'UPlus-S1 수정',
    '投入金额不能超过交易所可用余额': '투자 금액은 거래소의 사용 가능 잔액을 초과할 수 없습니다',
    'Orbit 策略信息不完整，请刷新后重试': 'Orbit 전략 정보가 불완전합니다. 새로고침 후 다시 시도해 주세요.',
    'Orbit 策略操作失败': 'Orbit 전략 작업에 실패했습니다',
    'Orbit 策略操作成功': 'Orbit 전략이 업데이트되었습니다',
    'Orbit 数据读取失败': 'Orbit 데이터를 불러오지 못했습니다',
    '历史策略不可操作': '과거 전략은 수정할 수 없습니다',
    'Orbit 策略状态已更新，请核对后重新确认': 'Orbit 전략 상태가 변경되었습니다. 최신 내용을 검토한 후 다시 확인해 주세요.',
    'Orbit 委托已更新，已重新加载最新记录': 'Orbit 주문이 변경되어 최신 주문을 다시 불러왔습니다.',
    '请先绑定 OKX 交易所 API': '먼저 OKX 거래소 API를 연결해 주세요',
    '当前账号已冻结，无法创建策略': '계정이 동결되어 전략을 생성할 수 없습니다.',
    '确认恢复当前策略？': '현재 전략을 재개하시겠습니까?',
    '已加载全部委托': '모든 주문을 불러왔습니다',
    '暂无当前仓位': '현재 포지션이 없습니다',
    '暂无当前委托': '현재 주문이 없습니다',
    '买入平空': '숏 청산 매수',
    '买入开多': '롱 진입 매수',
    '卖出平多': '롱 청산 매도',
    '卖出开空': '숏 진입 매도',
    '初始保证金': '초기 증거금',
    '保证金率': '증거금 비율',
    '已成交数量': '체결 수량',
    '完成交易': '완료된 거래',
    '状态未知': '알 수 없는 상태',
    '策略参数': '전략 매개변수'
  }
}
